import { Tooltip, withStyles } from '@material-ui/core';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow:
      '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.13), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.1)',
    fontSize: 12,
    textAlign: 'center',
    maxWidth: 350,
  },
  arrow: {
    color: theme.palette.common.white,
    '&:before': {
      boxShadow:
        '0 6.4px 14.4px 0 rgba(0, 0, 0, 0.13), 0 1.2px 3.6px 0 rgba(0, 0, 0, 0.1)',
    },
  },
}))(Tooltip);

export default LightTooltip;
